export default __webpack_public_path__ + "static/media/empty-contact.d6b9ffae.svg";